module.exports = __webpack_public_path__ + "img/calendar.46aabf76.svg";